<div class="iqac-page">
  <app-header-style-seven></app-header-style-seven>

  <section class="page-shell iqac-shell">
    <div class="custom-container">
      <div class="content-shell iqac-content-shell">
        <!-- HERO -->
        <header class="page-hero">
          <span class="page-kicker">Quality &amp; Excellence</span>
          <h1>Internal Quality Assurance Cell (IQAC)</h1>
          <p>
            IQAC of FMCET promotes continuous improvement in academic quality,
            institutional processes, innovation, governance, and stakeholder
            satisfaction through structured quality assurance practices.
          </p>
        </header>

        <!-- TABS -->
        <mat-tab-group mat-align-tabs="center" class="iqac-tabs">
          <!-- HOME -->
          <mat-tab label="Home">
            <div class="tab-pane-wrap">
              <section class="info-card">
                <div class="info-copy">
                  <p>
                    The Internal Quality Assurance Cell (IQAC) of FMCET has been
                    established to ensure continuous improvement in the quality of
                    education, research, administration, and institutional
                    performance. The primary aim of IQAC is to create a system for
                    conscious, consistent, and catalytic action to improve the
                    academic and administrative performance of the institution.
                  </p>

                  <p>
                    The college IQAC was established on <strong>June 3, 2018</strong>,
                    after a comprehensive year-long evaluation. Following the revised
                    NAAC framework of 2017, the structure of IQAC members was framed
                    with participation from the Head of the Institution, academic and
                    administrative leaders, faculty representatives, external experts,
                    management representatives, and stakeholders.
                  </p>
                </div>
              </section>

              <section class="panel-card">
                <div class="panel-head">
                  <div>
                    <span class="panel-tag">Institution Direction</span>
                    <h2>Vision &amp; Mission</h2>
                  </div>
                </div>

                <div class="split-grid">
                  <div class="mini-card">
                    <h3>Vision</h3>
                    <p>
                      The vision of IQAC of FMCET is to make the institution a center
                      of excellence in quality assurance, fostering a culture of
                      continuous improvement, innovation, and academic excellence.
                      It aims to deliver world-class education, empower students with
                      skills, and contribute positively to society through research,
                      industry collaboration, and community engagement.
                    </p>
                  </div>

                  <div class="mini-card">
                    <h3>Mission</h3>
                    <p>
                      The mission of IQAC is to promote and sustain a culture of
                      quality in all aspects of the college’s functioning. It seeks
                      to facilitate continuous improvement through effective quality
                      assurance mechanisms, innovation in teaching and research, an
                      inclusive learning environment, transparent processes, and
                      data-driven decision-making.
                    </p>
                  </div>
                </div>
              </section>

              <section class="panel-card">
                <div class="panel-head">
                  <div>
                    <span class="panel-tag">Core Responsibilities</span>
                    <h2>Functions of IQAC</h2>
                  </div>
                </div>

                <div class="function-list">
                  <div class="function-card" *ngFor="let item of iqacFunctions; trackBy: trackByTitle">
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.description }}</p>
                  </div>
                </div>

                <div class="coordinator-note">
                  <span class="note-label">Coordinator - IQAC</span>
                  <h3>Dr. R. Natarajan</h3>
                </div>
              </section>
            </div>
          </mat-tab>

          <!-- MEMBERS -->
          <mat-tab label="IQAC Members">
            <div class="tab-pane-wrap">
              <section class="panel-card">
                <div class="panel-head">
                  <div>
                    <span class="panel-tag">Official Committee</span>
                    <h2>IQAC Members</h2>
                  </div>
                </div>

                <div class="table-wrap">
                  <table class="table committee-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Name</th>
                        <th>Designation</th>
                        <th>Position</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let m of iqacMembers; trackBy: trackBySno">
                        <td>{{ m.sno }}</td>
                        <td>{{ m.name }}</td>
                        <td>{{ m.designation }}</td>
                        <td>{{ m.position }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>
            </div>
          </mat-tab>

          <!-- MINUTES -->
          <mat-tab label="IQAC - Minutes of Meeting">
            <div class="tab-pane-wrap">
              <section class="panel-card">
                <div class="panel-head">
                  <div>
                    <span class="panel-tag">Records &amp; Documentation</span>
                    <h2>Minutes of Meeting</h2>
                  </div>
                </div>

                <div class="minutes-card">
                  <div class="minutes-icon">
                    <i class="bx bx-layer"></i>
                  </div>
                  <div class="minutes-copy">
                    <h3>IQAC Minutes of Meeting</h3>
                    <p>
                      Access the official minutes of meeting and supporting records
                      related to IQAC proceedings and quality assurance activities.
                    </p>
                  </div>
                  <a routerLink="/mom" class="minutes-link">Open Minutes</a>
                </div>
              </section>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </section>
</div>